import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class GetNewSoftwareRequest extends Request {
    constructor(mode) {
        super({
            req: RequestTypes.GET_NEW_SOFTWARE,
            req_id: 0,
            mode: mode
        });
    }
}

export default GetNewSoftwareRequest;